import { Slide } from "react-reveal";

const ICTSupplyOffers = () => {
  return (
    <section className="solution-item-section section-spacing-50 world-bg">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="solution-offers-container flex">
              <div className="solution-offers-textside">
                <div className="section-head width-600 section-spacing-40 no-padding-top">
                  <p className="section-tag boldTitle">OFFERS</p>
                  <Slide top>
                    <h2 className="section-title ntuna-text-fill">
                      What's Included
                    </h2>
                  </Slide>
                  <p className="section-subtitle font-inter-regular">
                    We don't just sell ICT equipment. We guide your decisions,
                    ensure compatibility, configure your systems, and give you
                    the flexibility to either consult or purchase instantly.
                  </p>
                </div>
                <div className="section-body">
                  <ul className="offers-list-container">
                    <li className="offers-list">
                      <h3>Needs Assessment & Smart ICT Equipment Selection</h3>
                      <ul>
                        <li>
                          <span>
                            Use-case analysis(office, school, personal)
                          </span>
                        </li>
                        <li>
                          <span>Performance requirement mapping</span>
                        </li>
                        <li>
                          <span>Existing infrastructure audit</span>
                        </li>
                        <li>
                          <span>Compatibility with existing systems</span>
                        </li>
                        <li>
                          <span>Budget alignment & optimization</span>
                        </li>
                        <li>
                          <span>Phased procurement planning(if needed)</span>
                        </li>
                        <li>
                          <span>Future scalability planning</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Computers, Laptops & Workstation Solutions</h3>
                      <ul>
                        <li>
                          <span>
                            Desktop computers(entry, mid, high-performance)
                          </span>
                        </li>
                        <li>
                          <span>
                            Laptops(business, student, professional-grade)
                          </span>
                        </li>
                        <li>
                          <span>
                            Custom-built workstations(design, engineering, heavy
                            tasks)
                          </span>
                        </li>
                        <li>
                          <span>High-perfomance systems</span>
                        </li>
                        <li>
                          <span>
                            Monitors(standard, dual setup, high-resolution)
                          </span>
                        </li>
                        <li>
                          <span>Docking stations & multi-device setups</span>
                        </li>
                        <li>
                          <span>
                            Input & output devices(keybaords, mouse, speakers,
                            ergonomic tools)
                          </span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Networking & Connectivity Infrastructure</h3>
                      <ul>
                        <li>
                          <span>
                            Routers (home, business, entreprise-level)
                          </span>
                        </li>
                        <li>
                          <span>Network Switches (managed/unmanaged)</span>
                        </li>
                        <li>
                          <span>
                            Wireless access points(Wifi coverage planning)
                          </span>
                        </li>
                        <li>
                          <span>Structured cabling(LAN setup readiness)</span>
                        </li>
                        <li>
                          <span>
                            Internet hardware(modems, mifis, USB & ethernet
                            cables, fiber support devices)
                          </span>
                        </li>
                        <li>
                          <span>
                            Network Segmentation(for departments or labs)
                          </span>
                        </li>
                        <li>
                          <span>
                            Bandwidth optimization & load distribution
                          </span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Printing, Scanning & Document Systems</h3>
                      <ul>
                        <li>
                          <span>
                            Printers(laser, inkjet,high-volume,multifunction)
                          </span>
                        </li>
                        <li>
                          <span>Scanners(flatbed, document scanners)</span>
                        </li>
                        <li>
                          <span>Copiers & shared devices</span>
                        </li>
                        <li>
                          <span>Print network configurations</span>
                        </li>
                        <li>
                          <span>Ink/toner planning & supply guidance</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>School ICT & Computer Lab Equipment </h3>
                      <ul>
                        <li>
                          <span>
                            Student workstations(optimized for learning)
                          </span>
                        </li>
                        <li>
                          <span>Teacher/admin control systems</span>
                        </li>
                        <li>
                          <span>Lab-specific devices & accessories</span>
                        </li>
                        <li>
                          <span>
                            Shared systems(printers, photocopiers, etc)
                          </span>
                        </li>
                        <li>
                          <span>Exam ready configurations</span>
                        </li>
                        <li>
                          <span>
                            Safe setup considerations(power & accessories,
                            layout readiness)
                          </span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Storage, Backup & Data Management</h3>
                      <ul>
                        <li>
                          <span>
                            External storage devices (harddrives, memory cards,
                            SSDs, etc)
                          </span>
                        </li>
                        <li>
                          <span>Network Attached Storage (NAS)</span>
                        </li>
                        <li>
                          <span>Backup drives & systems</span>
                        </li>
                        <li>
                          <span>Data transfer & migration tools </span>
                        </li>
                        <li>
                          <span>
                            Backup strategy guidance (local + cloud readiness)
                          </span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Power, Protection & Electrical Support Systems</h3>
                      <ul>
                        <li>
                          <span>UPS(Uninteruptible Power Supply) systems</span>
                        </li>
                        <li>
                          <span>Surge protectors</span>
                        </li>
                        <li>
                          <span>Power distribution units</span>
                        </li>
                        <li>
                          <span>Backup power planning guidance</span>
                        </li>
                        <li>
                          <span>Device protection strategies</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Peripherals, Accessories & Completion Components</h3>
                      <ul>
                        <li>
                          <span>Cables (network, HDMI, power, connectors)</span>
                        </li>
                        <li>
                          <span>Adapters & converters</span>
                        </li>
                        <li>
                          <span>External drives & accessories</span>
                        </li>
                        <li>
                          <span>Audio/visual accessories</span>
                        </li>
                        <li>
                          <span>Mounting & setup accessories</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Software, Licensing & System Configuration</h3>
                      <ul>
                        <li>
                          <span>
                            Operating systems installation(Windows, Linux, etc)
                          </span>
                        </li>
                        <li>
                          <span>Essential productivity software setup</span>
                        </li>
                        <li>
                          <span>Anti-virus & basic security tools</span>
                        </li>
                        <li>
                          <span>Licensing & activations</span>
                        </li>
                        <li>
                          <span>User account configuration</span>
                        </li>
                        <li>
                          <span>System optimization for performance</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Pre-delivery, Configuration & Quality Assurance</h3>
                      <ul>
                        <li>
                          <span>Device insoection & verification</span>
                        </li>
                        <li>
                          <span>Performance testing</span>
                        </li>
                        <li>
                          <span>Hardware diagnostics</span>
                        </li>
                        <li>
                          <span>Compatibility checks</span>
                        </li>
                        <li>
                          <span>Pre-installation of required tools</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Delivery, Logistics & Handling</h3>
                      <ul>
                        <li>
                          <span>Secure packaging</span>
                        </li>
                        <li>
                          <span>Transportation coordination</span>
                        </li>
                        <li>
                          <span>On-site delivery</span>
                        </li>
                        <li>
                          <span>Bulk delivery handling(for institutions)</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Installation, Setup & System Integration</h3>
                      <ul>
                        <li>
                          <span>On-site device installation</span>
                        </li>
                        <li>
                          <span>Network connection setup</span>
                        </li>
                        <li>
                          <span>Integration with existing systems</span>
                        </li>
                        <li>
                          <span>Multi-device synchronization</span>
                        </li>
                        <li>
                          <span>Testing after installation</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Documentation, Handover & Client Clarity</h3>
                      <ul>
                        <li>
                          <span>Equipment list documentation</span>
                        </li>
                        <li>
                          <span>System Overview</span>
                        </li>
                        <li>
                          <span>Basic usage guidance</span>
                        </li>
                        <li>
                          <span>Warranty information</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Warranty, Support & After-sales service</h3>
                      <ul>
                        <li>
                          <span>Manufacturer warranties</span>
                        </li>
                        <li>
                          <span>Technical support guidance</span>
                        </li>
                        <li>
                          <span>Troubleshooting assistance</span>
                        </li>
                        <li>
                          <span>Repair & replacement coordination</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Upgrade Path & Lifecycle Planning</h3>
                      <ul>
                        <li>
                          <span>Upgrade recommendations</span>
                        </li>
                        <li>
                          <span>Lifecycle planning for devices</span>
                        </li>
                        <li>
                          <span>Performance improvement pathways</span>
                        </li>
                        <li>
                          <span>Expansion readiness</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ICTSupplyOffers;
